let common = require('../admin-common.js');

$(document).on('click', '.clear-data-order-search', function() {
  $('#q_school_code_cont').val('');
  $('#q_school_school_name_cont').val('');
  $('#q_order_set_code_cont').val('');
  $('#q_order_set_order_set_name_cont').val('');
  $('#q_order_set_school_year_eq').val('');
  $('#q_confirmed_status_eq').val('all');
  $('#q_export_status_eq').val('all');
});

$(document).on('click', '#download-data', function() {
  let reservation_ids = [];
  let address_code = $('#address_code').val();
  $(':checkbox:checked').each(function(i){
    reservation_ids[i] = $(this).attr('reservation_ids');
  });

  if (!common.AddressCodeRegex(address_code)) {
    common.AddClassErrorAddressCode();
  } else if (reservation_ids.length < 1) {
    common.RemoveClassErrorAddressCode();
    $('.warning-text p').text(common.MSG_EXTRACT_CSV);
    $('#warning-extract-modal').modal('show');
  } else {
    common.RemoveClassErrorAddressCode();
    $.ajax({
      url: '/agency/data_orders/download_temporary',
      type:'POST',
      dataType:'script',
      data: { reservation_ids: reservation_ids, address_code: address_code},
      success: function(data){
       return true;
      }
    });
  }
});

$(document).on('click', '#download-data-invoice', function() {
  let reservation_ids = [];
  let address_code = $('#address_code').val();
  $(':checkbox:checked').each(function(i){
    reservation_ids[i] = $(this).attr('reservation_ids');
  });
  if (!common.AddressCodeRegex(address_code)) {
    common.AddClassErrorAddressCode();
  } else if (reservation_ids.length < 1) {
    common.RemoveClassErrorAddressCode();
    $('.warning-text p').text(common.MSG_EXTRACT_CSV);
    $('#warning-extract-modal').modal('show');
  } else {
    common.RemoveClassErrorAddressCode();
    $('#loading-icon').show();
    $.ajax({
      url: '/agency/data_orders/download_invoice_excel',
      type: 'POST',
      dataType: 'script',
      data: { reservation_ids: reservation_ids, address_code: address_code},
      success: function(data){
        $('#loading-icon').hide();
        if (data) {
          return true
        } else {
          $('.warning-text p').text(common.MSG_INVOICE_ERROR);
          $('#warning-extract-modal').modal('show');
        }
      }
    });
  }
});

$(document).on('click', '#extract-data-invoice-pdf', function() {
  let reservation_ids = [];
  let address_code = $('#address_code').val();
  $(':checkbox:checked').each(function(i){
    reservation_ids[i] = $(this).attr('reservation_ids');
  });
  if (!common.AddressCodeRegex(address_code)) {
    common.AddClassErrorAddressCode();
  } else if (reservation_ids.length < 1) {
    common.RemoveClassErrorAddressCode();
    $('.warning-text p').text(common.MSG_EXTRACT_CSV);
    $('#warning-extract-modal').modal('show');
  } else {
    common.RemoveClassErrorAddressCode();
    $('#loading-icon').show();
    $.ajax({
      url: '/agency/data_orders/download_invoice_pdf',
      type: 'POST',
      dataType: 'script',
      data: { reservation_ids: reservation_ids, address_code: address_code },
      success: function(data){
        $('#loading-icon').hide();
        if (data) {
          return true
        } else {
          $('.warning-text p').text(common.MSG_INVOICE_ERROR);
          $('#warning-extract-modal').modal('show');
        }
      }
    });
  }
});

$(document).on('click', '#send-requests', function() {
  if ($('.reservation-item-checkbox:checked').length === 0) {
    $('.warning-text p').text(common.MSG_NOT_DATA_REQUEST);
    $('#warning-extract-modal').modal('show');
  } else {
    $('#send-request-comment').modal('show');
  }
});

$(document).on('click', '#request-comment-submit', function() {
  const invalid_reservation_flag = $('.reservation-item-checkbox:checked[data-confirmed-flg="1"]').length > 0;
  if (invalid_reservation_flag) {
    $('.warning-text p').text(common.MSG_A_CR_0027);
    $('#warning-extract-modal').modal('show');
    return;
  }
  let reservation_checkeds = $('.reservation-item-checkbox:checked');
  if (reservation_checkeds.length === 0) {
    $('.warning-text p').text(common.MSG_NOT_DATA_REQUEST);
    $('#warning-extract-modal').modal('show');
    return;
  }
  let request_comment = document.getElementById('request-comment-select').value;
  let reservation_ids = [];
  reservation_checkeds.each(function(){
    reservation_ids.push($(this).attr('reservation_ids'));
  });
  $.ajax({
    url: '/agency/data_orders/confirmation_request',
    type:'PATCH',
    dataType:'script',
    data: { reservation_ids: reservation_ids, request_comment: request_comment, url: window.location.href },
    success: function(data) {
      return true;
    }
  });
});
